import type { FaireThemeEntity } from "../../entity_types/theme";

export const non_tarnish_gold_staples: FaireThemeEntity = {
  token: "non-tarnish-gold-staples",
  type: "theme",
  name: "Non-Tarnish Gold Staples",
  description: "High-quality 18K gold-plated jewelry designed to stay bright through every wash and wear. Perfect for your customers looking for water-resistant and hypoallergenic everyday essentials.",
  teaser: "K&K Visage Beauty Lounge customers likely prioritize low-maintenance elegance. These non-tarnish pieces complement a beauty-focused lifestyle where jewelry needs to withstand skincare routines and daily activities.",
  detail: "The additional_context highlights that the retailer's most recent orders, such as the Éclaire and Evereign necklaces, specifically feature 18K gold plating and water-resistant, non-tarnish properties.",
  bgColor: "#FDE8D0",
  tileBgColor: "#3b6b3b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_kf82txecnk",
    "p_ygqpn33gdu",
    "p_ut3tbs6mrw",
    "p_7rer5bw4qz",
    "p_pdvfyz7trd",
    "p_85zuvdfqvw",
    "p_97zg46rmhh",
    "p_hhvckrk4ev",
    "p_vpnd3gf2p2",
    "p_xjutj35u7u",
    "p_ufjavmwa64",
    "p_78kqz3bu74",
    "p_ea35egy4z5",
    "p_aud73vzpr2",
    "p_cva2y6pxqf",
    "p_c6vqwv5kqb",
    "p_xewqp98nk4",
    "p_pqf2f49nzz",
    "p_67r23q3gye",
    "p_j7nfmmc4ce",
    "p_xh2ydbj634",
    "p_zcxs6hxgxs",
    "p_hr2c2qxn5f",
    "p_7aj8n8fwkr",
    "p_9de3mat7p2",
    "p_jhcrb92fnq",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
